import CCButton from '@/Atoms/CCButton';
import Spacer from '@/Atoms/Spacer';
import CCColors from '@/Utils/CCColors';
import {FontSizes, vs} from '@/Utils/Dimensions';
import {View} from 'react-native';
import styles from '../SupportModal/styles';
import {ScreenName} from '@/navigators/StackConstants';
import {CommonActions, useNavigation} from '@react-navigation/native';
import {formatDateToDDMMYYYY, formatTimeHHMM} from '@/Utils/CommonUtils';
import CCText from '@/Atoms/CCText';
import Ionicons from 'react-native-vector-icons/Ionicons';

const SuccessComponent = ({commDate, ticketId, currentRoute, handleClose}) => {
  const navigation = useNavigation();
  return (
    <View style={styles.successContainer}>
      <Ionicons
        name="checkmark-circle"
        size={100}
        color={CCColors?.Green}
        style={styles.successIcon}
      />
      <Spacer spacing={vs(10)} />
      <CCText style={styles.modalTitle}>We have received your query</CCText>
      <Spacer spacing={vs(10)} />
      <CCText style={styles.successText}>
        Thank you for submitting your issue. Your ticket ID is {ticketId}. Our
        team will reach out to you before the mentioned SLA time{' '}
        {commDate
          ? `${formatDateToDDMMYYYY(commDate)} ${formatTimeHHMM(commDate)}`
          : '--'}
        .
      </CCText>
      <Spacer spacing={vs(20)} />
      <View style={styles.infoRow}>
        <View style={styles.infoBox}>
          <CCText fontSize={20} color={CCColors.Primary.Brown}>
            #
          </CCText>
          <View style={styles.verticalLine} />
          <View>
            <CCText
              fontSize={FontSizes[12]}
              color={CCColors?.TextColor?.LightGrey}>
              Ticket ID
            </CCText>
            <CCText
              fontSize={FontSizes[12]}
              color={CCColors?.TextColor?.Primary}>
              {ticketId}
            </CCText>
          </View>
        </View>
        <View style={styles.infoBox}>
          <Ionicons
            name="time-outline"
            size={20}
            color={CCColors.Primary.Brown}
          />
          <View style={styles.verticalLine} />
          <View>
            <CCText
              fontSize={FontSizes[12]}
              color={CCColors?.TextColor?.LightGrey}>
              Ticket SLA
            </CCText>
            <CCText
              fontSize={FontSizes[12]}
              color={CCColors?.TextColor?.Primary}>
              {formatDateToDDMMYYYY(commDate)} | {formatTimeHHMM(commDate)}
            </CCText>
          </View>
        </View>
      </View>
      <Spacer spacing={vs(25)} />
      <View style={styles.buttonRow}>
        <CCButton
          onPress={() => {
            if (currentRoute === ScreenName?.SupportTicket) {
              navigation.dispatch(
                CommonActions.reset({
                  index: 0,
                  routes: [{name: ScreenName?.SupportTicket}],
                }),
              );
            } else {
              navigation.navigate(ScreenName?.SupportTicket);
            }
            handleClose();
          }}
          style={styles.viewTicketBtn}
          contentContainerStyle={{paddingVertical: 12, paddingHorizontal: 50}}
          titleStyle={{
            fontSize: FontSizes[16],
            color: CCColors?.TextColor?.Dark,
          }}>
          View Ticket
        </CCButton>
        <CCButton
          onPress={() => {
            if (currentRoute === ScreenName?.SupportTicket) {
              navigation.dispatch(
                CommonActions.reset({
                  index: 0,
                  routes: [{name: ScreenName?.SupportTicket}],
                }),
              );
            }
            handleClose();
          }}
          style={styles.okayBtn}
          contentContainerStyle={{paddingVertical: 12, paddingHorizontal: 50}}
          titleStyle={{
            fontSize: FontSizes[16],
            color: CCColors?.TextColor?.Dark,
          }}>
          Okay
        </CCButton>
      </View>
      <Spacer spacing={vs(20)} />
    </View>
  );
};
export default SuccessComponent;
